export default "/_next/static/chunks/fonts/proximanova-bold-webfont-67a5122c1036622a0de802505a70c3d6.woff2";